import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ProfileDetailsComp } from './profiledetails';
import { AddNewUser } from '../../models/user';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { AddNewProfile, GetProfileList, UpdateProfile } from '../../models/profile';

export const ProfileDetails = () => {
    const userData = useUserStore;
    const [getProfileDetails, setGetProfileDetails] = useState(false);
    const [profileSearchObj, setProfileSearchObj] = useState({});

    const [profileDataObj, setProfileDataObj] = useState({});

    const [txtProfileName, settxtProfileName] = useState('');
    const [txtProfileNameErr, settxtProfileNameErr] = useState('');
    const [txtProfileDesc, settxtProfileDesc] = useState('');
    const [txtProfileDescErr, settxtProfileDescErr] = useState('');
    const [ddlProfileAssignedRoutes, setddlProfileAssignedRoutes] = useState([]);
    const [ddlProfileAssignedRoutesErr, setddlProfileAssignedRoutesErr] = useState('');
    const [ddlProfileAssignedLeadStages, setddlProfileAssignedLeadStages] = useState([]);
    const [ddlProfileAssignedLeadStagesErr, setddlProfileAssignedLeadStagesErr] = useState('');
    const [ddlProfileAssignedDealStages, setddlProfileAssignedDealStages] = useState([]);
    const [ddlProfileAssignedDealStagesErr, setddlProfileAssignedDealStagesErr] = useState('');

    const [mode, setMode] = useState('add');
    const [addProfile, setAddProfile] = useState(false);
    const [editProfile, setEditProfile] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();


    const state = {
        mode: mode,
        addProfile: addProfile,
        editProfile: editProfile,
        txtProfileName: txtProfileName,
        txtProfileNameErr: txtProfileNameErr,
        txtProfileDesc: txtProfileDesc,
        txtProfileDescErr: txtProfileDescErr,
        ddlProfileAssignedRoutes: ddlProfileAssignedRoutes,
        ddlProfileAssignedRoutesErr: ddlProfileAssignedRoutesErr,
        ddlProfileAssignedLeadStages: ddlProfileAssignedLeadStages,
        ddlProfileAssignedLeadStagesErr: ddlProfileAssignedLeadStagesErr,
        ddlProfileAssignedDealStages: ddlProfileAssignedDealStages,
        ddlProfileAssignedDealStagesErr: ddlProfileAssignedDealStagesErr,

        alertMsg: alertMsg,
        alertType: alertType,
        showAlert: showAlert,

        routes: ['Users', 'Profiles', 'Tickets', 'Assigned']

    }

    useEffect(() => {
        let profile_id = params.profile_id;
        if (profile_id != undefined && profile_id != null && profile_id != '' && profile_id != 'new') {
            setMode('edit');
            setProfileSearchObj({
                'txtProfileId': profile_id
            });
            setGetProfileDetails(true);

        }
    }, []);

    const HandleInputs = (e, name) => {
        let value = e.target.value;
        if (name == 'txtProfileName') {
            settxtProfileName(value)
        }
        else if (name == 'txtProfileDesc') {
            value = value.toLowerCase();
            settxtProfileDesc(value)
        }
        else if (name == 'ddlProfileAssignedRoutes') {
            setddlProfileAssignedRoutes(value)
        }
        else if (name == 'ddlProfileAssignedLeadStages') {
            setddlProfileAssignedLeadStages(value)
        }
        else if (name == 'ddlProfileAssignedDealStages') {
            setddlProfileAssignedDealStages(value)
        }

    }

    const AddProfile = () => {
        if (txtProfileName.trim() == '') {
            settxtProfileNameErr('Enter Profile Name');
            return false;
        }
        else {
            settxtProfileNameErr('');
        }

        setProfileDataObj({
            txtProfileName: txtProfileName,
            txtProfileDesc: txtProfileDesc,
            ddlProfileAssignedRoutes: ddlProfileAssignedRoutes,
            ddlProfileAssignedLeadStages: ddlProfileAssignedLeadStages,
            ddlProfileAssignedDealStages: ddlProfileAssignedDealStages,
            txtProfileId: params.profile_id,
        })

        if (mode == 'add') {
            console.log(profileDataObj);
            setAddProfile(true);
        }
        else {
            setEditProfile(true);
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route);
    }

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
            if (type == 'success' && mode == 'add') {
                NavigateTo('profiles')
            }
        }, 1000)

    }


    const ProfileDetailsResponse = (res) => {
        if (res != false) {
            let profileData = res.data.profilelistresponse.rows[0];
            settxtProfileName(profileData.profile_name);
            settxtProfileDesc(profileData.profile_desc);
            setddlProfileAssignedRoutes(profileData.profile_assigned_routes);
            setddlProfileAssignedLeadStages(profileData.profile_assigned_lead_stages !== undefined && profileData.profile_assigned_lead_stages !== '' ? profileData.profile_assigned_lead_stages : []);
            setddlProfileAssignedDealStages(profileData.profile_assigned_booking_stages !== undefined && profileData.profile_assigned_booking_stages !== '' ? profileData.profile_assigned_booking_stages : []);
            // setddlProfileAssignedDealStages(profileData.profile_assigned_booking_stages);
        }
        else {
            setShowAlert(true);
            setAlertType('error');
            setAlertMsg('Profile Not Found');
        }
        setGetProfileDetails(false);

    }

    const AddNewProfileResponse = (res) => {
        console.log(res);
        if (res != false && res != 'error') {
            setShowAlert(true);
            setAlertType('success');
            setAlertMsg(res.data.profileentryresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error');
            setAlertMsg('Some Error');
        }
        setAddProfile(false);
    }

    const UpdateProfileResponse = (res) => {
        //  console.log(res);
        if (res != false && res != 'error') {
            setShowAlert(true);
            setAlertType('success');
            setAlertMsg(res.data.profileupdatesresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error');
            setAlertMsg('Some Error');
        }
        setEditProfile(false);
    }


    return (
        <Box>
            <ProfileDetailsComp
                mystate={state}
                HandleInputs={HandleInputs}
                NavigateTo={NavigateTo}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                AddProfile={AddProfile}
            />
            {((addProfile === true) ? AddNewProfile(pnkstore, profileDataObj, userData.getState().token, AddNewProfileResponse) : "")}
            {((editProfile === true) ? UpdateProfile(pnkstore, profileDataObj, userData.getState().token, UpdateProfileResponse) : "")}
            {((getProfileDetails === true) ? GetProfileList(pnkstore, profileSearchObj, userData.getState().token, ProfileDetailsResponse) : "")}
        </Box>
    )
}